import * as React from "react"

function SendNewEmailIco(props) {
  return (
    <svg
      width={219}
      height={196}
      viewBox="0 0 219 196"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M45.466 23.115c-11.53 3.497-23.564 10.27-25.79 21.14-2.784 13.595 11.102 26.27 9.516 40.024-1.178 10.22-10.399 17.825-17.14 26.072C3.68 120.592-1.41 133.497.347 146.16c1.45 10.462 7.356 19.963 13.902 28.667 4.544 6.04 9.638 12.002 16.581 15.698 6.914 3.681 15.1 4.81 23.096 5.247a154.29 154.29 0 0039.098-2.863c18.899-3.851 37.338-11.301 56.688-10.54 16.98.666 34.022 7.657 50.453 3.7 2.822-.68 5.605-1.705 7.814-3.442 2.569-2.022 4.18-4.856 5.523-7.694 9.544-20.175 7.068-46.097-10.606-61.06-10.698-9.056-25.951-13.642-34.133-24.658-9.954-13.403-6.068-31.381-10.043-47.148-.945-3.746-2.408-7.489-5.152-10.41-3.342-3.558-8.225-5.549-12.96-7.38-8.082-3.128-16.412-5.79-25.323-5.35-6.013.298-11.238 1.637-17.332 1.11-18.22-1.573-34.758-2.3-52.486 3.077"
          fill="#FFF0EB"
        />
        <path
          d="M158.666 183.495c0 3.207-21.963 5.807-49.055 5.807s-49.054-2.6-49.054-5.807c0-3.206 21.962-5.806 49.054-5.806 27.092 0 49.055 2.6 49.055 5.806"
          fill="#FAD4C3"
        />
        <path
          d="M147.67 38.72v135.918c0 5.494-4.447 9.95-9.935 9.95H81.49c-5.488 0-9.94-4.456-9.94-9.95V38.72a9.925 9.925 0 014.43-8.275 9.868 9.868 0 015.51-1.674h56.245c5.488 0 9.934 4.456 9.934 9.95"
          fill="#EE0000"
        />
        <path
          d="M136.505 181.375H82.719c-4.174 0-7.558-3.387-7.558-7.565V39.936c0-4.178 3.384-7.566 7.558-7.566h53.786c4.174 0 7.558 3.388 7.558 7.566V173.81c0 4.178-3.384 7.565-7.558 7.565"
          fill="#FFF"
        />
        <path
          d="M122.289 37.071H96.935a2.029 2.029 0 01-2.028-2.03v-4.324h29.41v4.324c0 1.122-.909 2.03-2.028 2.03"
          fill="#EE0000"
        />
        <path
          d="M114.13 35.094h-12.049a.875.875 0 010-1.751h12.05a.875.875 0 010 1.75M118.017 34.218a.875.875 0 11-1.75 0 .875.875 0 011.75 0"
          fill="#FFF"
        />
        <g transform="translate(78.513 136.66)">
          <rect fill="#EE0000" x={1.52} width={59.238} height={14.385} rx={1.292} />
          <ellipse
            stroke="#FFF"
            strokeWidth={0.898}
            cx={43.587}
            cy={6.743}
            rx={3.232}
            ry={3.247}
          />
          <path
            d="M43.266 7.704a.092.092 0 01-.06.02.092.092 0 01-.059-.02.06.06 0 010-.097l1.045-.854-1.045-.854a.06.06 0 010-.097.098.098 0 01.12 0l1.103.902a.06.06 0 010 .098l-1.104.902z"
            stroke="#FFF"
            strokeWidth={0.898}
            fill="#FFF"
          />
          <text
            fontFamily="Sparkasse-Bold, .\x7F"
            fontSize={7.18}
            fontWeight="bold"
            fill="#FFF"
          >
            <tspan x={17.716} y={8.938}>
              {"SEND"}
            </tspan>
          </text>
        </g>
        <g>
          <path
            fill="#BE0000"
            d="M124.865 86.08l-28.403.254-.116-14.362 28.403-.252z"
          />
          <path fill="#EE0000" d="M96.346 71.973l14.11-11.512 14.293 11.26z" />
          <path
            stroke="#EE0000"
            strokeWidth={0.5}
            fill="#FFF"
            d="M121.317 62.096l-21.695.193.211 26.076 21.695-.194z"
          />
          <path
            fill="#EE0000"
            d="M101.04 67.509l.007.871 18.707-.166-.007-.872zM101.061 70.145l18.707-.167-.007-.872-18.707.167zM101.076 71.909l18.706-.167-.007-.872-18.706.167zM101.09 73.673l18.707-.167-.007-.872-18.707.167zM101.104 75.437l18.707-.167-.007-.871-18.707.166zM115.61 76.297l-14.498.13.007.87 14.498-.128z"
          />
          <path
            fill="#EE0000"
            d="M96.346 71.973l.159 19.563 28.402-.253-.158-19.563-14.108 11.713z"
          />
          <path fill="#EE0000" d="M96.504 91.536l14.11-11.511 14.293 11.258z" />
          <g fill="#BE0000">
            <path d="M96.504 91.536l11.507-10.211.512.41zM124.907 91.283l-12.173-9.588.503-.417z" />
          </g>
        </g>
        <g>
          <path
            d="M65.806 10.25c-.17-.323-.33-.654-.473-.982l.247-.108c.141.322.297.647.465.964l-.239.126z"
            fill="#484867"
          />
          <path
            d="M100 4.514a13.686 13.686 0 00-2.113-.073l-.012-.27a13.828 13.828 0 012.154.075l-.03.268zm-6.19.898l-.116-.243a9.77 9.77 0 012.042-.711l.06.264a9.528 9.528 0 00-1.986.69zm10.273.16a14.865 14.865 0 00-2.004-.675l.068-.261a14.147 14.147 0 012.042.689l-.106.248zm3.308 2.493a6.07 6.07 0 00-1.469-1.473l.158-.22a6.357 6.357 0 011.533 1.54l-.222.153zm-16.71.066l-.227-.146c.24-.375.517-.73.823-1.056.189-.202.391-.397.602-.578l.176.204c-.203.176-.4.363-.581.558a7.018 7.018 0 00-.793 1.018zm17.722 3.971l-.264-.053c.078-.39.117-.78.117-1.158 0-.311-.027-.62-.08-.917l.266-.047c.055.312.083.637.083.964 0 .397-.04.804-.122 1.211zm-18.899.01l-.27-.008a8.632 8.632 0 01.329-2.141l.259.075a8.38 8.38 0 00-.318 2.074zm48.87.168l-.016-.27a38.455 38.455 0 012.143-.073l.002.27c-.705.005-1.42.03-2.128.073zm6.378.139c-.7-.075-1.413-.13-2.122-.166l.013-.27c.714.036 1.433.092 2.137.167l-.028.269zm-10.605.354l-.045-.267a39.722 39.722 0 012.122-.306l.032.268c-.7.082-1.41.184-2.109.305zm14.802.345a35.396 35.396 0 00-2.088-.411l.045-.267a35.93 35.93 0 012.103.415l-.06.263zm-18.95.605l-.074-.26a39.121 39.121 0 012.076-.535l.06.263c-.69.157-1.383.337-2.061.532zm-61.677.013a16.442 16.442 0 01-1.376-1.656l.218-.16c.408.564.863 1.112 1.354 1.63l-.196.186zm84.706.587a33.122 33.122 0 00-2.02-.667l.076-.258c.688.203 1.374.428 2.036.67l-.092.255zm-27.046.805l-.102-.25.366-.15a38.91 38.91 0 011.636-.615l.09.255c-.549.192-1.095.398-1.626.61l-.364.15zm-19.57.78l-.198-.183a8.128 8.128 0 001.215-1.709l.238.127a8.378 8.378 0 01-1.255 1.766zm50.504.138A31.487 31.487 0 00155 15.12l.11-.247c.656.29 1.305.606 1.93.935l-.125.24zm-66.908.29a11.362 11.362 0 01-.6-2.076l.265-.05c.127.682.324 1.364.586 2.027l-.251.098zm-18.39.152a20.053 20.053 0 01-1.725-1.282l.172-.207c.533.442 1.106.868 1.703 1.263l-.15.226zm50.49.418l-.12-.242c.707-.35 1.339-.653 1.93-.926l.113.245c-.59.272-1.219.574-1.923.923zm-19.283 1.371l-.102-.25c.68-.277 1.31-.603 1.874-.965l.146.227a11.89 11.89 0 01-1.918.988zm57.7.013a29.489 29.489 0 00-1.764-1.187l.141-.23c.609.378 1.208.781 1.78 1.198l-.157.219zm-85.11.202a23.02 23.02 0 01-1.946-.91l.125-.239c.62.327 1.268.629 1.924.9l-.102.25zm42.887.352l-.123-.24 1.9-.977.124.24-1.901.977zm-19.62.558l-.047-.266a25.26 25.26 0 002.077-.446l.069.261c-.639.168-1.326.316-2.1.45zm-19.167.36a24.766 24.766 0 01-2.077-.544l.079-.257a23.614 23.614 0 002.055.536l-.057.265zm14.927.225l-.032-.269c.63-.073 1.258-.152 1.885-.234l.232-.03.036.267-.233.031c-.628.082-1.257.16-1.888.235zm-10.684.387a33.677 33.677 0 01-2.131-.233l.038-.268c.682.098 1.394.175 2.114.232l-.02.27zm6.422.007l-.016-.27a69.28 69.28 0 002.097-.165 11.355 11.355 0 01-1.28-1.682l.228-.143c.378.603.809 1.167 1.281 1.675l-.198.184.022.232c-.755.07-1.453.126-2.134.169zm-3.308.11c-.324 0-.649-.004-.972-.011l.005-.27c.71.016 1.42.014 2.13-.004l.006.27c-.39.01-.78.015-1.17.015zm27.59.241l-.112-.245a78.566 78.566 0 001.924-.922l.12.242c-.701.347-1.333.65-1.931.925zm49.31.3a31.857 31.857 0 00-1.575-1.43l.174-.207c.09.077.18.154.27.233.438.38.881.787 1.318 1.21l-.188.195zm-53.275 1.322l-.088-.255a40.576 40.576 0 001.99-.758l.1.25a40.088 40.088 0 01-2.002.763zm-14.7.113c-.488-.225-.965-.48-1.417-.76a9.696 9.696 0 01-.461-.304l.155-.22c.147.102.295.2.447.294.443.274.91.525 1.389.744l-.113.246zm10.552.982l-.047-.266a26.158 26.158 0 002.073-.462l.069.26c-.698.186-1.403.343-2.095.468zm-6.42.2c-.725-.1-1.434-.247-2.11-.439l.075-.26c.662.189 1.36.333 2.071.432l-.037.267zm2.476.166c-.11 0-.222-.001-.332-.003l.004-.27c.693.013 1.4-.015 2.12-.077l.023.27c-.614.053-1.225.08-1.815.08zm64.261.342a49.849 49.849 0 00-1.41-1.599l.199-.183c.464.504.928 1.03 1.417 1.608l-.206.174zm2.66 3.337c-.43-.565-.867-1.129-1.31-1.685l.211-.169c.444.56.88 1.123 1.314 1.69l-.214.164zm2.578 3.41l-1.287-1.708.217-.161 1.285 1.707-.215.162zm2.574 3.414l-1.287-1.707.215-.163 1.287 1.707-.215.163zm2.574 3.413l-1.287-1.707.215-.162 1.286 1.707-.214.162z"
            fill="#444"
          />
          <path fill="#484867" d="M179.02 40.344l-.65-.863.215-.163.65.862z" />
          <path fill="#BE0000" d="M68.541 5.196l-.29 8.644L39.914 0z" />
          <path fill="#EE0000" d="M75.9.29l-7.359 4.906L39.913 0z" />
          <path d="M65.937 6.779L39.914 0 58.19 11.967z" fill="#EE0000" />
          <path fill="#D50000" d="M68.251 13.84l-2.314-7.062-5.132 3.44z" />
        </g>
      </g>
    </svg>
  )
}

export default SendNewEmailIco
